import axios from 'axios';
import {
  LOGIN_REMOVE_LINE_ITEM_BEGIN,
  LOGIN_REMOVE_LINE_ITEM_SUCCESS,
  LOGIN_REMOVE_LINE_ITEM_FAILURE,
  LOGIN_REMOVE_LINE_ITEM_DISMISS_ERROR,
} from './constants';

export function removeLineItem(args = {}) {
  return (dispatch) => {
    // optionally you can have getState as the second argument
    dispatch({
      type: LOGIN_REMOVE_LINE_ITEM_BEGIN,
    });
    const { estimateFeatureId, lineItemUuid } = args;

    // const token = process.env.REACT_APP_TOKEN;
    const options = {
      headers: {
        // 'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    };

    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.delete(
        `${process.env.REACT_APP_ORGANIZATION_ENGINE_URL}line-items/${lineItemUuid}/estimate/${estimateFeatureId}`,
        options,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: LOGIN_REMOVE_LINE_ITEM_SUCCESS,
            data: res,
          });
          resolve(res);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: LOGIN_REMOVE_LINE_ITEM_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissRemoveLineItemError() {
  return {
    type: LOGIN_REMOVE_LINE_ITEM_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case LOGIN_REMOVE_LINE_ITEM_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        removeLineItemPending: true,
        removeLineItemError: null,
      };

    case LOGIN_REMOVE_LINE_ITEM_SUCCESS:
      // The request is success
      return {
        ...state,
        removeLineItemPending: false,
        removeLineItemError: null,
      };

    case LOGIN_REMOVE_LINE_ITEM_FAILURE:
      // The request is failed
      return {
        ...state,
        removeLineItemPending: false,
        removeLineItemError: action.data.error,
      };

    case LOGIN_REMOVE_LINE_ITEM_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        removeLineItemError: null,
      };

    default:
      return state;
  }
}
